import { QueryClient, useMutation, useQuery, useQueryClient } from 'react-query';

import {
  CityResponse,
  fetchAutocompleteCityGmapRequest,
  FetchAutocompleteCityParams,
  fetchAutocompleteCityRequest,
  FetchNearbyCitiesParams,
  fetchNearbyCitiesRequest
} from '../lib/city';
import { ErrorResponse, UseQueryConfig } from '../lib/types';

export const useFetchNearbyCitiesQuery = ({ city, withDelivery }: FetchNearbyCitiesParams, config?: UseQueryConfig<CityResponse[]>) => {
  return useQuery<CityResponse[], ErrorResponse>({
    queryKey: ['cities', city, withDelivery],
    queryFn: () => fetchNearbyCitiesRequest({ city, withDelivery }),
    ...config
  });
};

// PREFETCH
export const prefetchNearbyCitiesQuery = async (queryClient: QueryClient, { city, withDelivery }: FetchNearbyCitiesParams) => {
  await queryClient.prefetchQuery({
    queryKey: ['cities', city, withDelivery],
    queryFn: () => fetchNearbyCitiesRequest({ city, withDelivery })
  });
};

export const useFetchAutocompleteCityMutation = ({ onSuccess }: { onSuccess?: (response: CityResponse[], params: FetchAutocompleteCityParams) => void }) => {
  const queryClient = useQueryClient();
  return useMutation<CityResponse[], Error, FetchAutocompleteCityParams>((params) => fetchAutocompleteCityRequest(params), {
    onSuccess: (data, params) => {
      queryClient.removeQueries();
      if (onSuccess) {
        onSuccess(data, params);
      }
    }
  });
};

export const useFetchAutocompleteCityGmapMutation = ({
  onSuccess
}: {
  onSuccess?: (response: CityResponse[], params: FetchAutocompleteCityParams) => void;
}) => {
  const queryClient = useQueryClient();
  return useMutation<CityResponse[], ErrorResponse, FetchAutocompleteCityParams>((params) => fetchAutocompleteCityGmapRequest(params), {
    onSuccess: (data, params) => {
      queryClient.removeQueries();
      if (onSuccess) {
        onSuccess(data, params);
      }
    }
  });
};
